import {
    changeFieldProperty,
    setFieldListOptions,
    setFieldVisibility,
} from "../../../../../apps/KpModule/actions"
import {GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api"

export const module_ = {
    name: 'Decision',
    tKey: 'Décision dossier',
    object: 'ReliefFund',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'applicationNumber'},
            {path: 'organizationTradingName', tKey: 'tradingName'},
            {path: 'object'},
            {path: 'needsTypes', tKey: 'needs'},
            {path: 'totalTotalAmountsInEuros', tooltip: true},
            {path: 'totalRequestedAmountsInEuros', tooltip: true},
            {path: 'fundingRateForEuros', width: 120},
            //{path: 'totalTotalAmountsInKilograms', tooltip: true},
            {path: 'totalRequestedAmountsInKilograms', tooltip: true},
            //{path: 'fundingRateForKilograms', width: 120},
            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', editable: false},
                {path: 'organizationTradingName', tKey: 'tradingName', editable: false},
                {path: 'object', editable: false},
                {path: 'description', tKey: 'Présentation des difficultés rencontrées', type: 'richTextEditor', editable: false},
                {
                    path: 'needs',
                    type: 'accordion',
                    newable: false,
                    viewMap: {
                        dt: [
                            { path: 'natureOfHelp', display: 'nameWithUnit', tKey: 'type'},
                            { path: 'totalAmountInEuros'},
                            { path: 'requestedAmountInEuros'},
                            { path: 'awardedAmountInEuros'},
                            //{ path: 'totalAmountInKilograms'},
                            { path: 'requestedAmountInKilograms'},
                            { path: 'awardedAmountInKilograms'},
                            { path: 'form', tKey: "Forme d’aide", translate: true }
                        ],
                        form: [
                            {
                            path: 'natureOfHelp',
                            display: 'nameWithUnit',
                            tKey: 'type',
                            editable: false,
                            fieldPath: ['id', 'name', 'nameWithUnit', 'eligibleToEmergencyFund', 'facilityRelated', 'unit'],
                            subscriptions: {
                                onChange: (newValue, oldValue, {store, module}) => {
                                    const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                    const landTypeField = needsField.viewMap.form.fields.find(field => field.path === 'landType')
                                    const totalAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInEuros')
                                    const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                    const requestedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInKilograms')
                                    const awardedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInEuros')
                                    const awardedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInKilograms')

                                    store.dispatch(setFieldVisibility(landTypeField.id, !!newValue && newValue.facilityRelated))

                                    store.dispatch(setFieldVisibility(totalAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                    store.dispatch(setFieldVisibility(requestedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                    store.dispatch(setFieldVisibility(awardedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))

                                    store.dispatch(setFieldVisibility(requestedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                    store.dispatch(setFieldVisibility(awardedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                }
                            }
                            },
                            {
                                path: 'landType', tKey: "Le dossier concerne un lieu", display: 'name', required: true, editable: false, translate: true, sortList: false,
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')
                                        store.dispatch(setFieldVisibility(landTypeProofField.id, !!newValue))
                                        store.dispatch(changeFieldProperty(landTypeProofField.id, 'tKey', `landTypeProof_${newValue?.id}`))
                                    }
                                }
                            },
                            { path: 'totalAmountInEuros', editable: false },
                            {
                                path: 'requestedAmountInEuros',
                                editable: false,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        if(newValue) {
                                            const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                            const awardedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInEuros')
                                            store.dispatch(changeFieldProperty(awardedAmountInEurosField.id, 'maxValue', newValue))
                                        }
                                    }
                                }
                            },
                            {
                                path: 'awardedAmountInEuros',
                                required: true,
                                wholePositiveNumber: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const formField = needsField.viewMap.form.fields.find(field => field.path === 'form')

                                        const isStrictlyPositiveInteger = Number.isInteger(newValue) && newValue > 0;

                                        store.dispatch(changeFieldProperty(formField.id, 'required', isStrictlyPositiveInteger))
                                    }
                                }

                            },
                            { path: 'totalAmountInKilograms', editable: false, hidden: true },
                            {
                                path: 'requestedAmountInKilograms',
                                editable: false,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        if(newValue) {
                                            const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                            const awardedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'awardedAmountInKilograms')
                                            store.dispatch(changeFieldProperty(awardedAmountInKilogramsField.id, 'maxValue', newValue))
                                        }
                                    }
                                }
                            },
                            {
                                path: 'awardedAmountInKilograms',
                                required: true,
                                wholePositiveNumber: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const formField = needsField.viewMap.form.fields.find(field => field.path === 'form')

                                        const isStrictlyPositiveInteger = Number.isInteger(newValue) && newValue > 0;

                                        store.dispatch(changeFieldProperty(formField.id, 'required', isStrictlyPositiveInteger))
                                    }
                                }
                            },
                            { path: 'form', tKey: "Forme d’aide", required: true, translate: true },
                            { path: 'landTypeProof', required: true, fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false, hidden: true },
                            { path: 'supportingDocuments', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', tKey: "needSupportingDocuments_submission", editable: false}
                        ]
                    }
                },
                {path: 'studyCommitteeComment', type: 'richTextEditor', editable: false},
                {path: 'decision', tKey: 'boardOfDirectorsDecision', type: 'richTextEditor'},
                {path: 'conversations', tKey: "interactionZone"},
                {path: 'submitter', fieldPath: ['id', 'firstname', 'lastname', 'mail'], hidden: true},
                {path: 'ongoingLiberalities', hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const ongoingLiberalities = state.edit.object.data.ongoingLiberalities

                const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                const formField = needsField.viewMap.form.fields.find(field => field.path === 'form')

                store.dispatch(setFieldListOptions(formField.id,
                    ongoingLiberalities
                        ? ['advanceOnLegacy', 'directAssociationPayment', 'thirdPartyDirectPayment']
                        : ['directAssociationPayment', 'thirdPartyDirectPayment']
                ))
            }
        }
    ],
    filters: [
        'userHasAuthorization',
        {
            path: 'statuses',
            client: true,
            object: 'ReliefFundApplicationStatus',
            type: 'tags',
            default: [{id: 'controlled'}],
            filters: [
                {
                    name: 'decisionStatuses',
                    match: object => {
                        return  ['controlled', 'accepted', 'refused', 'closed'].includes(object.id)
                    }
                }
            ],
            display: 'name',
            query: (context) => {
                const statuses =  context.data?.statuses || []
                return statuses.length ? { status: {$in: statuses.map(status => status.id)}} : {}
            }
        }
    ]
}
